import {MultiValueGenericProps} from 'react-select';
import {ISelectOption} from '..';

export const MultiValueContainer = ({selectProps, data}: MultiValueGenericProps) => {
    const values = selectProps.value as unknown as ISelectOption<string>[];

    if (values) {
        return values[values.length - 1].label === data.label ? data.label : data.label + ', ';
    }

    return '';
};
